import React from 'react';
import {
  VictoryChart,
  VictoryStack,
  VictoryBar,
  VictoryAxis,
  VictoryLabel,
} from 'victory';
import { reportingCopy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';
import EcapCompletionChartPopover from './EcapCompletionChartPopover';

export default function AllEcapCompletionsChart(props) {
  return (
    <div className="all-ecap-completions-chart">
      <EcapCompletionChartPopover data={props.data[1]} />
      <div className="all-ecap-completions-chart__chart">
        <VictoryChart domainPadding={{ x: 90 }} height={400}>
          <VictoryStack
            colorScale={reportingCopy.ecapCompletions.colorScale}
            labels={({ datum }) => datum._y1}
            labelComponent={
              <VictoryLabel style={{ fontSize: 20, fontFamily: 'Roboto' }} />
            }
          >
            {Object.entries(props.data[1]).map(([year, counts]) => {
              return (
                <VictoryBar
                  barWidth={60}
                  data={[
                    { x: 'Total Incomplete', y: counts.incomplete },
                    { x: 'Total Complete', y: counts.complete },
                  ]}
                  key={year}
                />
              );
            })}
          </VictoryStack>
          <VictoryAxis
            style={{ tickLabels: { fontSize: 20, fontFamily: 'Roboto' } }}
          />
        </VictoryChart>
      </div>
    </div>
  );
}
